import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'zwi-terms-of-use-dialog',
    templateUrl: './terms-of-use-dialog.component.html',
    styleUrls: ['./terms-of-use-dialog.component.scss'],
    standalone: false
})
export class TermsOfUseDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
